import { OPTIMISER_STATUS as types } from 'actions/actionTypes';

export const initialState = {
  summary: {
    tenancyId: null,
    contractVersion: null,
    total: 0,
    rows: [],
    optimiserRoster: null,
    warnings: { count: 0, records: [] }
  },
  summaryInFlight: false,
  summaryError: null,
  violations: {
    results: [],
    count: 0
  },
  violationsInFlight: false,
  violationsError: null,
  filters: {
    recordType: null,
    errorType: null
  },
  publishAttempts: { results: [], inFlight: false },
  writebackHistory: { results: [], inFlight: false, error: null }
};

export const optimiserStatus = (state = initialState, action) => {
  switch (action.type) {
  // /////////////////////////////////////////////////////////////////////////
  case types.SUMMARY_IN_FLIGHT: {
    return { ...state, summaryInFlight: true, summaryError: null };
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.SUMMARY_SUCCESS: {
    const { data } = action;
    return {
      ...state,
      summaryInFlight: false,
      summary: {
        tenancyId: data.tenancy_id,
        contractVersion: data.contract_version,
        total: data.total || 0,
        rows: data.summary || [],
        optimiserRoster: data.optimiser_roster || null,
        warnings: data.warnings || { count: 0, records: [] }
      }
    };
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.SUMMARY_FAILURE: {
    return { ...state, summaryInFlight: false, summaryError: action.error };
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.VIOLATIONS_IN_FLIGHT: {
    return { ...state, violationsInFlight: true, violationsError: null };
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.VIOLATIONS_SUCCESS: {
    const { data } = action;
    return {
      ...state,
      violationsInFlight: false,
      violations: {
        results: data.results || [],
        count: typeof data.count === 'number' ? data.count : 0
      }
    };
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.VIOLATIONS_FAILURE: {
    return { ...state, violationsInFlight: false, violationsError: action.error };
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.SET_FILTERS: {
    return { ...state, filters: { ...state.filters, ...action.filters } };
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.ATTEMPTS_IN_FLIGHT: {
    return { ...state, publishAttempts: { ...state.publishAttempts, inFlight: true } };
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.ATTEMPTS_SUCCESS: {
    return { ...state, publishAttempts: { results: action.data || [], inFlight: false } };
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.ATTEMPTS_FAILURE: {
    return { ...state, publishAttempts: { ...state.publishAttempts, inFlight: false } };
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.WRITEBACK_IN_FLIGHT: {
    return { ...state, writebackHistory: { ...state.writebackHistory, inFlight: true, error: null } };
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.WRITEBACK_SUCCESS: {
    const rows = Array.isArray(action.data) ? action.data : [];
    return {
      ...state,
      writebackHistory: {
        inFlight: false,
        error: null,
        results: rows.map(row => ({
          id: row.id,
          receivedAt: row.received_at || null,
          processedAt: row.processed_at || null,
          status: row.status || '',
          runId: row.run_id || '',
          createdCount: row.created_count || 0,
          updatedCount: row.updated_count || 0,
          deletedCount: row.deleted_count || 0,
          smsEnqueuedCount: row.sms_enqueued_count || 0,
          smsSkippedCount: row.sms_skipped_count || 0
        }))
      }
    };
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.WRITEBACK_FAILURE: {
    return { ...state, writebackHistory: { ...state.writebackHistory, inFlight: false, error: action.error } };
  }

  default:
    return state;
  }
};

export default optimiserStatus;
